export interface V2ListPagination {
  page?: number;
  per_page?: number;
  no_pagination?: boolean;
}

export interface V2ListOptions {
  filter?: Record<string, unknown>;
  pagination?: V2ListPagination;
  sort?: string;
  embed?: string;
  fields?: Record<string, string[] | string>;
  limit?: number;
}

function normalizeNoPagination(no_pagination?: boolean): number | undefined {
  if (no_pagination === undefined) return undefined;
  return no_pagination ? 1 : 0;
}

export function buildV2ListParams(options: V2ListOptions = {}): Record<string, unknown> {
  const params: Record<string, unknown> = {};
  const { filter, pagination, sort, embed, fields, limit } = options;

  if (filter) {
    Object.entries(filter).forEach(([key, value]) => {
      if (value === undefined || value === null) return;
      if (typeof value === 'string') {
        const trimmed = value.trim();
        if (trimmed === '') return;
        params[`filter[${key}]`] = trimmed;
        return;
      }
      if (Array.isArray(value)) {
        if (value.length === 0) return;

        params[`filter[${key}]`] = value.join(',');
        return;
      }

      params[`filter[${key}]`] = value;
    });
  }

  if (pagination) {
    if (pagination.page !== undefined) params.page = pagination.page;
    if (pagination.per_page !== undefined) params.per_page = pagination.per_page;

    const normalizedNoPagination = normalizeNoPagination(pagination.no_pagination);
    if (normalizedNoPagination !== undefined) params.no_pagination = normalizedNoPagination;
  }

  if (sort) params.sort = sort;
  if (embed) params.embed = embed;
  if (limit !== undefined) params.limit = limit;

  if (fields) {
    Object.entries(fields).forEach(([resource, value]) => {
      params[`fields[${resource}]`] = Array.isArray(value) ? value.join(',') : value;
    });
  }

  return params;
}
